/**
 * Growth Hub → Personal site & Bluerate（/app/landingpage）。
 * 打开页面打 STATSIG.COMMON.VIEW，value=personal_site_bluerate（菜单明文全小写）。
 *
 * 正在用：打开编辑页；首次点 Start setup；向导最后一步点 Next 完成初始化；
 * 点 Complete setup & publish（会顺带保存当前主组织，不另打 BLUERATE_ORG）；
 * Change primary organization 弹窗点 Save 打 BLUERATE_ORG（value=update）；
 * 之后点 Publish；确认 Unpublish；
 * 复制 Personal site 或 Bluerate 链接；保存自定义 slug；提交自定义域名申请；
 * Customize your page content 四个展示开关立刻落库（value=open|hide）；
 * Home equity 展示开关立刻落库（value=open|hide）；FAQ / Testimonials 弹窗点 Save。
 * 已不算：向导中间步骤 Next / Back、个人站文案自动保存、改 NMLS/姓名/州牌照自动重审、
 * FAQ / Testimonials 打开弹窗不存、Insert / Delete 未 Save、Cancel、
 * 计算器 Edit（Lenders / Closing cost）、填 HELOC/HELOAN URL、
 * 进页默认开、折叠区块、预览切 Bluerate|Personal site、打开链接、关弹窗、Stay listed、
 * 面包屑回 Growth Hub。
 * googain / gmcc 没有 Mortgage / Affordability 两个开关。
 * 侧边栏 My Site 进同一页，不另做一套。
 * 访客个人站、Bluerate marketplace 落地页不跨模块。
 */
export enum GrowthHubPersonalSiteEvent {
    /** 未初始化时点 Start setup */
    SETUP_START = 'PERSONAL_SITE_SETUP_START',
    /** 引导流程最后一步点 Next，完成初始化并进入编辑页 */
    INITIALIZE = 'PERSONAL_SITE_INITIALIZE',
    /** 未初始化时点 Complete setup & publish（顺带保存当前主组织） */
    COMPLETE_SETUP = 'PERSONAL_SITE_COMPLETE_SETUP',
    /**
     * Change primary organization 弹窗点 Save。
     * value 与 metadata.type 相同：update
     * 和 AUTH_ORG_CHANGE（顶栏切组织）不是同一入口。
     * Complete setup & publish 顺带保存主组织不另打这条。
     * Edit it in {org} 不算。
     */
    BLUERATE_ORG = 'PERSONAL_SITE_BLUERATE_ORG',
    /**
     * 点 Publish，或确认 Unpublish。
     * value 与 metadata.type 相同：publish|unpublish
     */
    PUBLISH = 'PERSONAL_SITE_PUBLISH',
    /**
     * 复制已发布链接。
     * 属性 type=personal|bluerate
     */
    COPY = 'PERSONAL_SITE_COPY',
    /** 保存 Personal site 自定义 slug */
    URL_UPDATE = 'PERSONAL_SITE_URL_UPDATE',
    /** 提交自定义域名申请 */
    DOMAIN_REQUEST = 'PERSONAL_SITE_DOMAIN_REQUEST',
    /**
     * Mortgage rate calculator 开关。
     * value 与 metadata.type 相同：open|hide
     */
    MORTGAGE_CALCULATOR_SWITCH = 'PERSONAL_SITE_MORTGAGE_CALCULATOR_SWITCH',
    /**
     * Affordability calculator 开关。
     * value 与 metadata.type 相同：open|hide
     */
    AFFORDABILITY_CALCULATOR_SWITCH = 'PERSONAL_SITE_AFFORDABILITY_CALCULATOR_SWITCH',
    /**
     * Frequently asked questions 开关。
     * value 与 metadata.type 相同：open|hide
     */
    FAQ_SWITCH = 'PERSONAL_SITE_FAQ_SWITCH',
    /** FAQ 弹窗点 Save */
    FAQ_UPDATE = 'PERSONAL_SITE_FAQ_UPDATE',
    /**
     * Customer testimonials 开关。
     * value 与 metadata.type 相同：open|hide
     */
    TESTIMONIAL_SWITCH = 'PERSONAL_SITE_TESTIMONIAL_SWITCH',
    /** Testimonials 弹窗点 Save */
    TESTIMONIAL_UPDATE = 'PERSONAL_SITE_TESTIMONIAL_UPDATE',
    /**
     * Display HELOC & HELOAN section 开关。
     * value 与 metadata.type 相同：open|hide
     */
    HOME_EQUITY_SWITCH = 'PERSONAL_SITE_HOME_EQUITY_SWITCH',
}
